import ValidationError from "../ValidationError";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import {faXmarkCircle} from '@fortawesome/pro-solid-svg-icons/faXmarkCircle';
import {faLoader} from "@fortawesome/pro-solid-svg-icons";
import {FormWrapperLabelType, FormWrapperMinimumType, FromWrapperType, InputWrapperType} from "./FormEntryWrapperTypes";

const FormWrapperLabel = (props: FormWrapperLabelType) => {
    return (
        <FormEntryWrapper invalid={props.invalid} isActive={props.isActive} value={props.value}>
            <label>
                {props.label} {props.labelExtra && ( <small>{props.labelExtra}</small> )}
            </label>
            <InputWrapper validationMessage={props.validationMessage as string} hasAddon={props.hasAddon} noValidation={props.noValidation}>
                {props.children}
            </InputWrapper>
        </FormEntryWrapper>
    )
}

const FormWrapperMinimum = (props: FormWrapperMinimumType) => {
    return (
        <FormEntryWrapper invalid={props.invalid} isActive={props.isActive} value={props.value}>
            <InputWrapper validationMessage={props.validationMessage} hasAddon={props.hasAddon} noValidation={props.noValidation}>
                {props.children}
            </InputWrapper>
        </FormEntryWrapper>
    )
}

const FormEntryWrapper = (props: FromWrapperType) => {
    return (
        <div className={`form-group ${props.isActive ? 'active' : !props.invalid ? '' : props.invalid ? 'invalid' : 'valid' }`}>
            {props.children}
        </div>
    )
}

const InputWrapper = (props: InputWrapperType) => {
    return (
        <div className={`input-state-wrapper ${props.hasAddon ? 'input-addon' : ''}`}>
            {props.noValidation ? (
                <>{props.children}</>
            ) : (
                <div className={'input-state'}>
                    {props.children}
                    <div className={'input-state-icon'}>
                        <FontAwesomeIcon icon={faCheckCircle} fixedWidth={true} />
                        <FontAwesomeIcon icon={faXmarkCircle} fixedWidth={true} />
                        <FontAwesomeIcon icon={faLoader} fixedWidth={true} spin={true} />
                    </div>
                </div>
            )}
            <ValidationError value={props.validationMessage as string} />
        </div>
    )
}

export default FormEntryWrapper

export { FormWrapperLabel, FormWrapperMinimum, InputWrapper }